import { Dispatch } from 'redux';

import { CLOSE_DRAWER, OPEN_DRAWER, SAVE_AND_RETRIEVE_QUOTE_RESET, SET_DRAWER_HYDRATION_STATE } from '../action-types';

export type DrawerHydrationState = {
  id: string;
  initialErrors: Record<string, string>;
  initialTouched: Record<string, boolean>;
  initialValues: Record<string, unknown>;
};

const closeDrawer = () => (dispatch: Dispatch) => dispatch({ type: CLOSE_DRAWER });

const openDrawer = (drawerId: string) => (dispatch: Dispatch) => dispatch({ id: drawerId, type: OPEN_DRAWER });

const resetDrawer = () => (dispatch: Dispatch) => dispatch({ type: SAVE_AND_RETRIEVE_QUOTE_RESET });

const setDrawerHydrationState = (payload: DrawerHydrationState) => (dispatch: Dispatch) =>
  dispatch({ payload, type: SET_DRAWER_HYDRATION_STATE });

export default {
  closeDrawer,
  openDrawer,
  resetDrawer,
  setDrawerHydrationState,
};
